var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2402_25826)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.7374,
    cy: 60,
    rx: 60.7394,
    ry: 60,
    fill: "#EC9832",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0676,
    cy: 60.3316,
    rx: 44.2961,
    ry: 43.7569,
    fill: "#EC9832",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 51C62.5913 51 64.1174 51.6321 65.2426 52.7574C66.3679 53.8826 67 55.4087 67 57V78C67 79.5913 66.3679 81.1174 65.2426 82.2426C64.1174 83.3679 62.5913 84 61 84C59.4087 84 57.8826 83.3679 56.7574 82.2426C55.6321 81.1174 55 79.5913 55 78V57C55 55.4087 55.6321 53.8826 56.7574 52.7574C57.8826 51.6321 59.4087 51 61 51Z",
    fill: "#EC9832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 42C67 43.5913 66.3679 45.1174 65.2426 46.2426C64.1174 47.3679 62.5913 48 61 48C59.4087 48 57.8826 47.3679 56.7574 46.2426C55.6321 45.1174 55 43.5913 55 42C55 40.4087 55.6321 38.8826 56.7574 37.7574C57.8826 36.6321 59.4087 36 61 36C62.5913 36 64.1174 36.6321 65.2426 37.7574C66.3679 38.8826 67 40.4087 67 42Z",
    fill: "#EC9832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2402_25826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.479,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopInfo);
export default __webpack_public_path__ + "static/media/pop_info.eda95dc322133da89673ee4898b07a56.svg";
export { ForwardRef as ReactComponent };